import { render, staticRenderFns } from "./UpperText.vue?vue&type=template&id=3d77cd2f&functional=true&"
var script = {}
import style0 from "./UpperText.vue?vue&type=style&index=0&id=3d77cd2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports